module.exports = __webpack_public_path__ + "static/media/10.c66656b0.svg";